<script>
import EzTable from '@/components/ui/Table/EzTable';
import EzEntityInfo from '@/components/ui/EntityInfo/EzEntityInfo';
import EzButton from '@/components/ui/Button/EzButton';
import { COMMON as commonCy } from '@weareneopix/qa-utils/dist/orderEz/common';

/**
 *
 * @version 1.0.0
 * @since 3.16.0
 */
export default {
  name: 'index',
  components: {
    EzTable,
    EzEntityInfo,
    EzButton,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      commonCy,
    };
  },
  methods: {
    goToExternalLink(item) {
      window.open(item.url, '_blank');
    },
  },
};
</script>

<template>
  <div class="linked-platforms">
    <div class="desktop-table">
      <ez-table
        :data="data"
        :columns="['orderNumber', 'name', 'actions']"
        :headers="{
          orderNumber: () => 'Order No.',
          name: () => 'External Platforms',
          actions: () => '',
        }"
        :columnProps="{
          orderNumber: { class: 'medium-cell' },
          actions: { class: 'large-cell' },
        }"
        disable-hover
      >
        <template #cell-orderNumber="{ row }">
          <span class="order-number">{{ row.orderNumber }}</span>
        </template>

        <template #cell-name="{ row }">
          <ez-entity-info
            img-width="2rem"
            img-height="2rem"
            img-border-radius="50%"
            :imgUrl="row.logo"
          >
            <div class="integration-info" :title="row.name">
              <span>{{ row.name }}</span>
            </div>
          </ez-entity-info>
        </template>

        <template #cell-actions="{ row }">
          <ez-button
            type="secondary"
            @click="goToExternalLink(row)"
            :data-cy="commonCy.SINGLE_ORDER.BUTTON__VIEW_ORDER"
          >
            View Order
          </ez-button>
        </template>
      </ez-table>
    </div>
    <div class="mobile-table">
      <div v-for="platform in data" :key="platform.id" class="mobile-table-item">
        <ez-entity-info
          img-width="2rem"
          img-height="2rem"
          img-border-radius="50%"
          :imgUrl="platform.logo"
        >
          <div class="integration-info" :title="platform.name">
            <span>{{ platform.name }}</span>
          </div>
        </ez-entity-info>
        <ez-button
          type="secondary"
          @click="goToExternalLink(platform)"
          :data-cy="commonCy.SINGLE_ORDER.BUTTON__VIEW_ORDER"
        >
          View Order
        </ez-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.linked-platforms {
  .integration-info {
    span {
      color: $color-gray-25;
      @include font-size(14px, 22px);
    }
  }
  .order-number {
    @include font-size(14px, 20px);
  }
  .mobile-table {
    display: none;
    margin-top: 1rem;
    &-item {
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  @media (max-width: 1023px) {
    .desktop-table {
      display: none;
    }
    .mobile-table {
      display: block;
    }
  }
}
</style>
